import PolicyLayout from './PolicyLayout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatBar from '../components/ChatBar';
import {
  ADDRESS,
  COMPANY_NAME,
  POLICY_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
} from '../constants/site';

export default function AboutPage() {
  return (
    <div className="page">
      <Header />
      <PolicyLayout
        title="About Us"
        updated={POLICY_UPDATED}
        intro={`${SITE_NAME} (${SITE_DOMAIN}) provides independent guidance and live support for Family Tree Maker users — from first install to TreeVault backup and computer migration.`}
      >
        <h2>What we do</h2>
        <p>
          We help home genealogists and family historians use Family Tree Maker with confidence.
          Our team offers step-by-step help for downloads, activation, sync, media links, FamilySearch
          connections, and moving trees between computers.
        </p>

        <h2>How we work</h2>
        <ul>
          <li>Live chat for real-time troubleshooting and clear next steps.</li>
          <li>Live chat when you need step-by-step help with an install or migration.</li>
          <li>Plain-language guidance tailored to your version and operating system.</li>
        </ul>

        <h2>Who operates this site</h2>
        <p>
          This website is operated by {COMPANY_NAME}, {ADDRESS}. We are an independent support
          provider and are not affiliated with, endorsed by, or sponsored by Family Tree Maker or
          its trademark owners. Product names are used for identification only.
        </p>

        <h2>Our commitment</h2>
        <p>
          We focus on practical, respectful support — helping you preserve your family history
          without unnecessary jargon or upsells. If we cannot resolve an issue, we explain why and
          suggest sensible alternatives.
        </p>
      </PolicyLayout>
      <Footer />
      <ChatBar />
    </div>
  );
}
